<template>
  <div :class="$style.container">
    <div :class="[$style.row, $style.row_header]">
      <div></div>
      <div><ModeDisplay level="1" /></div>
      <div><ModeDisplay level="1" limit /></div>
      <div><ModeDisplay level="2" /></div>
      <div><ModeDisplay level="2" limit /></div>
    </div>
    <div
      :class="$style.row"
      v-for="(unlockType, key) in userUnlocks"
      :key="key"
    >
      <div>
        <TitleThumb v-bind="unlockType.thumb">
          {{ unlockType.thumb.title }}
        </TitleThumb>
      </div>
      <div v-for="(unlock, n) in unlockType.unlocks" :key="n" :class="$style.level">
        <div :class="$style.levelLock" v-if="n > 0 && unlockType.unlocks[n - 1].score < threshold">
          <SvgIcon :size="30" :svg="LockSvg" />
        </div>
        <span v-else>{{ unlock.score + '%' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TitleThumb from '@/components/TitleThumb'
import ModeDisplay from '@/components/ModeDisplay'
import SvgIcon from '@/components/SvgIcon'
import LockSvg from '!svg-inline-loader?classPrefix!@mdi/svg/svg/lock.svg'

export default {
  components: {
    TitleThumb,
    ModeDisplay,
    SvgIcon,
  },
  computed: {
    LockSvg () { return LockSvg },
    orders () {
      return [
        { level: '1', limit: false },
        { level: '1', limit: true },
        { level: '2', limit: false },
        { level: '2', limit: true },
      ]
    },
    userUnlocks () {
      if (!this.user) {
        return
      }
      const unlocks = this.user.unlocks
      return this.thumbs.reduce((carry, thumb) => {
        const { key } = thumb
        const typeUnlocks = unlocks.filter(unlock => unlock.type == key)
        const orderedUnlocks = this.orders.map(order => {
          const found = typeUnlocks.find(unlock => {
            return unlock.level == order.level &&
              unlock.time_limited == order.limit
          })
          return { ...order, score: found ? found.score : 0 }
        })
        carry[key] = { unlocks: orderedUnlocks, thumb }
        return carry
      }, {})
    },
    ...mapState(['thumbs']),
    ...mapGetters('auth', {
      user: 'user',
      threshold: 'unlockThreshold',
    }),
  },
}
</script>

<style lang="scss" module>
.container {
  @apply h-full;
  @apply w-full;
  @apply overflow-auto;
}

.row {
  @apply flex;
  width: 720px;
  @apply mx-auto;
  @apply items-center;
  @apply mb-1;

  > div {
    width: 150px;
    @apply text-center;
  }

  > :nth-child(1) {
    width: 105px;
    height: 80px;

    > div {
      transform: scale(0.5) translate(-50%, -50%);
    }
  }
}

.row_header {
  @apply items-end;
}

.level {
  @apply relative;
}

.levelLock {
  @apply absolute;
  @apply inset-0;
  @apply m-auto;
  width: 30px;
  height: 30px;
  opacity: 0.5;
}
</style>